import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { formValueSelector, change } from 'redux-form';
import cx from 'classnames';
import Accordion from 'react-bootstrap/Accordion';
import withStyles from 'isomorphic-style-loader/withStyles';
import Button from 'react-bootstrap/Button';

import Loader from '../../../Common/Loader/Loader';
import CurrencyConverter from '../../../CurrencyConverter/CurrencyConverter';

import messages from '../../../../locale/messages';
import { createBooking } from '../../../../actions/siteadmin/ManualBooking/createBooking';
import ToolTipContent from '../../../Common/ToolTipContent/ToolTipContent';
import { getPricingDetails } from '../../../../helpers/bookingHelper';
import showToaster from '../../../../helpers/toastrMessgaes/showToaster';
import { getNearestPreferredPartner } from '../../../../actions/siteadmin/ManualBooking/getNearestPreferredPartner';

import AccordionArrow from '../../../../../public/Icons/accordionArrow.svg';
import bt from '../../../../components/commonStyle.css';

class PricingDetails extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selected: false,
            bookingArrow: false,
        }
        this.toggleSelected = this.toggleSelected.bind(this);
        this.toggleArrowSelected = this.toggleArrowSelected.bind(this);
    }

    toggleSelected() {
        this.setState((prevState) => ({
            selected: !prevState.selected,
        }));
    }

    toggleArrowSelected() {
        this.setState((prevState) => ({
            bookingArrow: !prevState.bookingArrow
        }));
    }

    renderSubCategory = (data) => {
        let hoursLabel, pricingType, price;
        hoursLabel = data.pricingDetails?.multiplierValue > 1 ? 'hr(s)' : 'hr';
        pricingType = data?.categoryData?.pricingType;
        price = pricingType == "hourly" ? Number(data.pricingDetails?.convertBasePrice) * Number(data.pricingDetails?.multiplierValue) :
            Number(data.pricingDetails?.convertBasePrice) * Number(data.quantity);
        return (
            <div className="commonSubCategoryPricingSubItem">
                <span>
                    {data?.name}&nbsp;{'x'}&nbsp;{pricingType == 'hourly' ? <span>{data?.pricingDetails?.multiplierValue}{hoursLabel} </span> : data?.quantity}
                </span>
                <CurrencyConverter amount={price} />
            </div>
        )
    }

    handleSubmit = async () => {
        const { email, firstName, lastName, phoneCountryCode, phoneDialCode, phoneNumber, preferredPartnerId, isPreferredProvider, scheduleFrom, bookingType } = this.props;
        if (isPreferredProvider && !preferredPartnerId) {
            return showToaster({ messageId: 'selectPartner', toasterType: 'error' });
        }
        const { createBooking, ordersDetails, categoryId, location, lat, lng, userId } = this.props;
        await createBooking({
            userId,
            email,
            firstName,
            lastName,
            phoneCountryCode,
            phoneDialCode,
            phoneNumber,
            bookingType,
            scheduleFrom: bookingType === 2 ? moment(scheduleFrom).unix() : null,
            ordersDetails: JSON.stringify(ordersDetails),
            categoryId: Number(categoryId),
            location,
            lat,
            lng,
            preferredPartnerId
        })
    }

    getPreferredProvider = () => {
        const { subCategoryId, userId, lat, lng, getNearestPreferredPartner } = this.props;
        getNearestPreferredPartner({ subCategoryId, userId, lat, lng, searchList: '' })
    }

    render() {
        const { formatMessage } = this.props.intl;
        const { ordersDetails, loader, resetForm, bookingLoading, base, rates, isRandomProviderSelection, isPreferredProvider, bookingType } = this.props;
        const { serviceFee, visitFee, total, subTotal } = getPricingDetails(ordersDetails, base, rates);

        let categoryName, showSubmit, submitMessage;

        categoryName = ordersDetails[0]?.categoryData?.name;
        showSubmit = (isRandomProviderSelection || isPreferredProvider || bookingType == 2)
        submitMessage = (isRandomProviderSelection || isPreferredProvider) ? messages?.bookNow : messages?.next;

        return (
            <>
                {loader && <div><Loader type="circle" show={loader} /></div>}
                {!loader && <div>
                    <p className='commonSubCategorySliderHeading'>  {formatMessage(messages.priceSummary)}</p>
                    <div className='commonSubCategoryPricingInfoContainer'>
                        <Accordion defaultActiveKey="0" className='commonSubCategoryPricingAccordion'>
                            <Accordion.Toggle eventKey="0" className='commonSubCategoryPricingAccordionHeading commonSubCategoryPricingItemWrapper' onClick={this.toggleSelected}>
                                <div className='commonSubCategoryPricingItem commonSubCategoryPricingSubHeading'>
                                    {categoryName}
                                    <span className='accordionArrow'>
                                        <img src={AccordionArrow} className={cx(!this.state.selected ? 'accordionArrowDown' : 'accordionArrowUp')} />
                                    </span>
                                </div>
                                <CurrencyConverter amount={subTotal} />
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="0" className='commonSubCategoryPricingAccordionBody'>
                                <div>
                                    {ordersDetails?.map((item) => { return (this.renderSubCategory(item)) })}
                                </div>
                            </Accordion.Collapse>
                        </Accordion>
                        {visitFee > 0 && <div className='commonSubCategoryPricingItemWrapper commonSubCategoryPricingSubHeading'><div className='commonSubCategoryPricingItem commonSubCategoryPricingItemAlignBase svgImg'><ToolTipContent label={formatMessage(messages.vistFeeContent)} />{formatMessage(messages.travelCharge)}</div><CurrencyConverter amount={visitFee} /></div>}
                        {serviceFee > 0 && <div className='commonSubCategoryPricingItemWrapper commonSubCategoryPricingSubHeading'><div className='commonSubCategoryPricingItem commonSubCategoryPricingItemAlignBase svgImg'><ToolTipContent label={formatMessage(messages.serviceFeeContent)} />{formatMessage(messages.serviceFee)}</div><CurrencyConverter amount={serviceFee} /></div>}
                        <hr className='commonSubCategoryPricingDivider' />
                        <div className='commonSubCategoryPricingItemWrapper commonSubCategoryPricingHeading'><div className='commonSubCategoryPricingItem'>{formatMessage(messages.total)}</div><CurrencyConverter amount={total} /></div>
                        <div className='commonSubCategoryPricingBtnContainer'>
                            <Button onClick={() => resetForm()} className={cx(bt.btnSecondary)}>{isPreferredProvider ? formatMessage(messages.back) : formatMessage(messages.reset)}</Button>
                            <Loader
                                type={"button"}
                                buttonType={"button"}
                                show={bookingLoading}
                                disabled={bookingLoading}
                                className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                                label={formatMessage(bookingType == 2 ? messages.scheduleNow : submitMessage)}
                                handleClick={() => showSubmit ? this.handleSubmit() : this.getPreferredProvider()}
                            />
                        </div>
                    </div>
                </div>
                }
            </>
        )
    }
}

const selector = formValueSelector('ManualBookingForm');

const mapState = (state) => ({
    userId: selector(state, 'userId'),
    email: selector(state, 'email'),
    firstName: selector(state, 'firstName'),
    lastName: selector(state, 'lastName'),
    phoneCountryCode: selector(state, 'phoneCountryCode'),
    phoneDialCode: selector(state, 'phoneDialCode'),
    phoneNumber: selector(state, 'phoneNumber'),
    categoryId: selector(state, 'categoryId'),
    location: selector(state, 'location'),
    scheduleFrom: selector(state, 'scheduleFrom'),
    // location: selector(state, 'location'),
    lat: selector(state, 'lat'),
    lng: selector(state, 'lng'),
    bookingType: selector(state, 'bookingType'),
    bookingLoading: state?.booking?.bookingLoading,
    isRandomProviderSelection: selector(state, 'isRandomProviderSelection'),
    isPreferredProvider: selector(state, 'isPreferredProvider'),
    preferredPartnerId: selector(state, 'preferredPartnerId'),
    base: state?.currency?.base,
    rates: state?.currency?.rates,
});
const mapDispatch = {
    change,
    createBooking,
    getNearestPreferredPartner
}

export default injectIntl(withStyles(bt)(connect(mapState, mapDispatch)(PricingDetails)));